import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import getNumberOfLayers from "../../../service/getNumberOfLayers"
import { isBuildUp, isFlexible, isMultiLayer, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidBoard = (values: EstimateValues, board?: string) => {
  const numberOfLayers = getNumberOfLayers(values)

  switch (board) {
    case ESTIMATE_CONSTANT.材質["FR-4"].value:
      return isRigid(values)

    case ESTIMATE_CONSTANT.材質["高Tg材（Tg180 FR-4）"].value:
    case ESTIMATE_CONSTANT.材質["パナソニック材（MEGTRON6）"].value:
      return isRigid(values) && !isBuildUp(values)

    case ESTIMATE_CONSTANT.材質["CEM-3"].value:
    case ESTIMATE_CONSTANT.材質["耐トラッキング材（CTI600 FR-4）"].value:
    case ESTIMATE_CONSTANT.材質["Rogers材（4350B）"].value:
      return isRigid(values) && !isBuildUp(values) && !isMultiLayer(values)

    case ESTIMATE_CONSTANT.材質["パナソニック材（R1705相当品FR-4）"].value:
      return isRigid(values) && !isBuildUp(values) && numberOfLayers <= 8

    case ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(2層以下)"].value:
      return isRigid(values) && !isBuildUp(values) && numberOfLayers <= 2
    case ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(4層)"].value:
      return isRigid(values) && !isBuildUp(values) && numberOfLayers === 4
    case ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(6層)"].value:
      return isRigid(values) && !isBuildUp(values) && numberOfLayers === 6
    case ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(8層以上)"].value:
      return isRigid(values) && !isBuildUp(values) && numberOfLayers >= 8

    case ESTIMATE_CONSTANT.材質["FR-1"].value:
      return isRigid(values) && !isBuildUp(values) && numberOfLayers === 1

    case ESTIMATE_CONSTANT.材質["銅箔＋接着層＋PI（ポリイミド）"].value:
    case ESTIMATE_CONSTANT.材質["銅箔＋PI（ポリイミド）"].value:
      return isFlexible(values)

    default:
      return false
  }
}

export default isValidBoard
